import { Component, inject } from '@angular/core';
import { DialogRef } from '@angular/cdk/dialog';
import { DatePipe } from '@angular/common';
import { DialogBaseComponent } from 'shared/dialogs/dialog-base/dialog-base.component';
import { TranslatePipe } from '@ngx-translate/core';
import { AppConfigService } from 'services/app-config.service';

@Component({
  selector: 'core-ui-update-info-modal',
  templateUrl: './update-info-dialog.component.html',
  imports: [DatePipe, DialogBaseComponent, TranslatePipe],
  styleUrl: './update-info-dialog.component.scss'
})
export class UpdateInfoDialogComponent {
  protected startDateTime: number;
  protected endDateTime: number;
  private dialogRef = inject(DialogRef);
  private appConfigService = inject(AppConfigService);

  constructor() {
    this.startDateTime = this.appConfigService.appConfig.updateInterval.startDateTime;
    this.endDateTime = this.appConfigService.appConfig.updateInterval.endDateTime;
  }

  public close(): void {
    this.dialogRef.close();
  }
}
